import { render, staticRenderFns } from "./quiz_finish.vue?vue&type=template&id=55f9f8ce&"
import script from "./quiz_finish.vue?vue&type=script&lang=js&"
export * from "./quiz_finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports